import React from 'react';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LISTING_TYPES } from 'util/constants';
import config from '../../config';

export const { Money } = sdkTypes;
export const TITLE_MAX_LENGTH = 60;
export const WALLPAPER_TITLE_MAX_LENGTH = 40;

export const descriptionMessages = {
  [LISTING_TYPES.LISTING]: 'EditListingDescriptionForm.description',
  [LISTING_TYPES.ENQUIRY]: 'EditListingDescriptionForm.enquiryDescription',
  [LISTING_TYPES.COMPANY]: 'EditListingDescriptionForm.companyDescription',
  [LISTING_TYPES.CLASS]: 'EditListingDescriptionForm.description',
  [LISTING_TYPES.FACILITY]: 'EditListingDescriptionForm.facilityDescription',
  [LISTING_TYPES.FREELANCER]: 'EditListingDescriptionForm.freelancerDescription',
  [LISTING_TYPES.MEMBERSHIP]: 'EditListingDescriptionForm.memberShipDescription',
  [LISTING_TYPES.ACADEMY]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.EVENT]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.REMOTE_TUTOR]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.COURSES]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.EDUCATION_COURSES]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.HOURLY_SESSION]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.TUTOR]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.PLAYER_PROFILE]: 'EditListingDescriptionForm.comanDescription',
};

export const descriptionPlaceholderMessages = {
  [LISTING_TYPES.LISTING]: 'EditListingDescriptionForm.descriptionPlaceholder',
  [LISTING_TYPES.ENQUIRY]: 'EditListingDescriptionForm.enquiryDescriptionPlaceholder',
  [LISTING_TYPES.COMPANY]: 'EditListingDescriptionForm.companyDescriptionPlaceholder',
  [LISTING_TYPES.CLASS]: 'EditListingDescriptionForm.classDescriptionPlaceholder',
  [LISTING_TYPES.EVENT]: 'EditListingDescriptionForm.eventPlaceholder',
  [LISTING_TYPES.FACILITY]: 'EditListingDescriptionForm.facilityDescriptionPlaceholder',
  [LISTING_TYPES.FREELANCER]: 'EditListingDescriptionForm.freelancerDescriptionPlaceholder',
  [LISTING_TYPES.MEMBERSHIP]: 'EditListingDescriptionForm.membershipDescriptionPlaceholder',
  [LISTING_TYPES.ACADEMY]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.REMOTE_TUTOR]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.COURSES]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.EDUCATION_COURSES]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.HOURLY_SESSION]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.TUTOR]: 'EditListingDescriptionForm.comanDescription',
  [LISTING_TYPES.PLAYER_PROFILE]: 'EditListingDescriptionForm.comanDescription',
};

export const listingMode = [
  {
    mode: 'Online',
    svg: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6349 22.9954C17.5083 22.9954 22.2697 18.0737 22.2697 12.0026C22.2697 5.93141 17.5083 1.00977 11.6349 1.00977C5.76139 1.00977 1 5.93141 1 12.0026C1 18.0737 5.76139 22.9954 11.6349 22.9954Z"
          fill="#0058FA"
          stroke="#FFB81D"
          strokeWidth="1.5"
        />
        <path
          d="M15.1081 12C15.1081 15.1162 14.6786 17.9205 13.9956 19.9319C13.6535 20.9397 13.255 21.7264 12.8321 22.2534C12.4061 22.7839 11.9995 23 11.6366 23C11.2736 23 10.867 22.7839 10.4411 22.2534C10.0181 21.7264 9.61964 20.9397 9.27748 19.9319C8.59451 17.9205 8.16504 15.1162 8.16504 12C8.16504 8.88384 8.59451 6.07945 9.27748 4.06801C9.61964 3.0603 10.0181 2.27347 10.4411 1.7466C10.867 1.21604 11.2736 1 11.6366 1C11.9995 1 12.4061 1.21604 12.8321 1.7466C13.255 2.27347 13.6535 3.0603 13.9956 4.06801C14.6786 6.07945 15.1081 8.88384 15.1081 12Z"
          fill="#0058FA"
          stroke="#FFB81D"
          strokeWidth="1.5"
        />
        <path
          d="M2.01619 17.1051H21.1864M1.4502 9.1543H22.2701H1.4502Z"
          stroke="#FFB81D"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    mode: 'In Person',
    svg: (
      <svg
        width="23"
        height="26"
        viewBox="0 0 23 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 25.9985H16.4441L6.24459 15.6406C4.36506 16.6178 2.78769 18.1017 1.68598 19.9291C0.58427 21.7565 0.000889513 23.8566 0 25.9985Z"
          fill="#0058FA"
        />
        <path
          d="M22.9626 25.9994C22.9635 23.8598 22.3828 21.7613 21.2843 19.9345C20.1858 18.1078 18.612 16.6234 16.7358 15.6445L10.2236 19.6912L16.4444 25.9994H22.9626Z"
          fill="#4889FF"
        />
        <path
          d="M17.5456 2.54637C15.9391 0.916523 13.7599 0.000565756 11.4874 2.61998e-07C9.21498 -0.000565232 7.03536 0.914307 5.42809 2.54336C3.82082 4.1724 2.91755 6.38219 2.91699 8.68657C2.91643 10.991 3.81863 13.2012 5.42512 14.831L6.24583 15.6422C7.87141 14.7971 9.67196 14.3563 11.4987 14.3563C13.3255 14.3563 15.126 14.7971 16.7516 15.6422L17.5545 14.828C19.1587 13.1978 20.0589 10.9883 20.0572 8.68533C20.0556 6.3823 19.1521 4.17419 17.5456 2.54637Z"
          fill="#FFB81D"
        />
        <path
          d="M11.4797 14.3594C9.65835 14.3598 7.86329 14.8001 6.24316 15.6439L11.4827 20.9721L16.7341 15.647C15.1094 14.7977 13.3075 14.3562 11.4797 14.3594Z"
          fill="#FFB81D"
        />
      </svg>
    ),
  },
];

export const ageGroup = [
  {
    mode: 'Adult',
    svg: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.688804 2.94456L11.0066 0.0555827C11.2569 -0.014504 11.4875 0.216142 11.4175 0.466449L8.52846 10.7842C8.44406 11.0856 8.02839 11.1151 7.90239 10.8286L5.73686 5.907C5.70332 5.83067 5.64232 5.76974 5.56599 5.73614L0.644437 3.57066C0.35797 3.44462 0.38743 3.02895 0.688804 2.94456Z"
          fill="#0058FA"
        />
      </svg>
    ),
  },
  {
    mode: 'Kids',
    svg: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5 8.75C18.8807 8.75 20 7.63071 20 6.25C20 4.86929 18.8807 3.75 17.5 3.75C16.1193 3.75 15 4.86929 15 6.25C15 7.63071 16.1193 8.75 17.5 8.75Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 26.25C24.5711 26.25 26.25 24.5711 26.25 22.5C26.25 20.4289 24.5711 18.75 22.5 18.75C20.4289 18.75 18.75 20.4289 18.75 22.5C18.75 24.5711 20.4289 26.25 22.5 26.25Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.5 26.25C9.57106 26.25 11.25 24.5711 11.25 22.5C11.25 20.4289 9.57106 18.75 7.5 18.75C5.42894 18.75 3.75 20.4289 3.75 22.5C3.75 24.5711 5.42894 26.25 7.5 26.25Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.3763 22.4999L16.2513 17.4999L10.1484 14.9999L13.8987 10.625L17.6487 13.7501H22.0237"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
  },
];

export const levelMode = [
  {
    mode: 'Begineer Level',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '1',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Beginner Can Rally',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '2',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Intermediate Can Rally',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '2.5',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Intermediate Can Play Points',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '3',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Intermediate / Advanced',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '3.5',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Advanced Rally',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '4',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Advanced Match Play',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '4.5',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Advanced Tournament Play',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '5',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Advanced High Level',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '5.5',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'Advanced National Level',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '6',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
  {
    mode: 'ATP/ITF/WTA',
    svg1: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
    points: '7',
    svg2: (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 33 40">
        <path
          d="M14,12 L6,12 L14,20 L6,28 L14,28 L22,20 L14,12 Z"
          fill="#005ef4"
          data-name="Layer 1"
        />
      </svg>
    ),
  },
];

export const levelModeClass = [
  {
    mode: 'Beginner',
    points: '1',
  },
  {
    mode: 'Intermediate',
    points: '2',
  },
  {
    mode: 'Advanced',
    points: '3',
  },
  {
    mode: 'Tournament Players',
    points: '4',
  },
];
export const tennisCategories = [
  {
    key: 'tennis',
    label: 'Tennis',
    svg: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.5 23.437C20.4374 25.2818 17.7672 26.3018 15 26.3018C12.2328 26.3018 9.56258 25.2818 7.5 23.437C7.73438 23.2214 7.95938 23.0058 8.175 22.7714C8.38761 22.5481 8.58791 22.3134 8.775 22.0683C10.3919 20.0687 11.2665 17.5709 11.25 14.9995C11.2538 12.4461 10.3837 9.96818 8.78437 7.97764C8.59687 7.73389 8.39062 7.50889 8.18437 7.28389C7.97812 7.05889 7.73438 6.82451 7.5 6.60889C9.56258 4.76406 12.2328 3.74414 15 3.74414C17.7672 3.74414 20.4374 4.76406 22.5 6.60889C22.2656 6.82451 22.0406 7.04014 21.825 7.27451C21.6124 7.49782 21.4121 7.73254 21.225 7.97764C19.6275 9.97296 18.757 12.4528 18.757 15.0089C18.757 17.5649 19.6275 20.0448 21.225 22.0401C21.4125 22.2839 21.6188 22.5089 21.825 22.7339C22.0313 22.9589 22.2656 23.1745 22.5 23.437Z"
          fill="#0058FA"
        />
        <path
          d="M9.37539 15C9.37948 17.0291 8.72114 19.0041 7.50039 20.625C7.29339 20.9169 7.06461 21.1926 6.81602 21.45C6.61914 21.6562 6.42227 21.8531 6.21602 22.0312C4.61848 20.0359 3.74805 17.5561 3.74805 15C3.74805 12.4439 4.61848 9.96407 6.21602 7.96875C6.42227 8.15625 6.61914 8.35313 6.81602 8.55938C7.05958 8.81792 7.28808 9.09024 7.50039 9.375C8.72361 10.9946 9.38223 12.9704 9.37539 15ZM26.2504 15C26.2587 17.5542 25.3882 20.0336 23.7848 22.0219C23.5785 21.8344 23.3816 21.6375 23.1848 21.4313C21.6684 19.8245 20.7682 17.7338 20.643 15.528C20.5177 13.3222 21.1756 11.1431 22.5004 9.375C22.7074 9.08314 22.9362 8.80735 23.1848 8.55C23.3816 8.34375 23.5785 8.14687 23.7848 7.96875C25.3861 9.9618 26.2563 12.4433 26.2504 15Z"
          fill="#FFB81D"
        />
      </svg>
    ),
  },
  {
    key: 'padel tennis',
    label: 'Padel Tennis',
    svg: (
      <svg
        width="30"
        height="24"
        viewBox="0 0 30 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4837_103)">
          <path
            d="M6.45939 8.24983C6.30574 8.36829 6.19339 8.54135 6.15657 8.74734C6.07793 9.18708 6.37075 9.60732 6.81048 9.68591L7.45747 9.80157L7.86998 9.8753L11.4941 10.5231C11.5415 10.5316 11.5891 10.5358 11.6364 10.5358C11.8321 10.5358 12.023 10.4647 12.172 10.3331L14.2865 8.46464L15.1211 13.53L15.4557 18.4382L11.0115 21.9657C10.4648 22.3996 10.3734 23.1946 10.8073 23.7413C11.0569 24.0557 11.4257 24.2196 11.7981 24.2195C12.0733 24.2195 12.3506 24.13 12.583 23.9455L17.5476 20.005C17.5543 19.9997 17.5599 19.9935 17.5665 19.988C17.5938 19.9654 17.6203 19.9418 17.6456 19.9169C17.6558 19.9069 17.6659 19.8969 17.6758 19.8866C17.7022 19.8589 17.7274 19.83 17.7512 19.8C17.7561 19.7939 17.7613 19.7882 17.7661 19.7821C17.7946 19.7448 17.8209 19.7058 17.8452 19.6653C17.8492 19.6587 17.8526 19.6519 17.8564 19.6452C17.876 19.6113 17.8939 19.5764 17.9104 19.5405C17.9152 19.53 17.9198 19.5195 17.9243 19.5088C17.9388 19.4746 17.9518 19.4395 17.9634 19.4037C17.9665 19.3939 17.9701 19.3844 17.973 19.3745C17.9864 19.3293 17.9979 19.2833 18.0063 19.236L18.0064 19.2347C18.0133 19.1957 18.0185 19.156 18.0217 19.1156L18.3918 14.4809L23.03 18.4781L23.6348 23.0544C23.7188 23.6902 24.2618 24.1528 24.8861 24.1528C24.9413 24.1528 24.9971 24.1492 25.0533 24.1417C25.7453 24.0503 26.2322 23.4152 26.1407 22.7232L25.4728 17.6695C25.4717 17.6608 25.4696 17.6522 25.4682 17.6435C25.4657 17.6272 25.4628 17.611 25.4597 17.5948C25.4555 17.5734 25.4508 17.5522 25.4456 17.5311C25.4415 17.5144 25.4372 17.4977 25.4323 17.4811C25.4265 17.4611 25.4199 17.4415 25.4131 17.4219C25.4072 17.4048 25.4015 17.3878 25.3949 17.371C25.3875 17.3522 25.3791 17.334 25.3708 17.3156C25.3632 17.2987 25.3561 17.2817 25.3477 17.2651C25.3371 17.2442 25.3252 17.2241 25.3135 17.2038C25.2993 17.1791 25.2841 17.1549 25.2681 17.1311C25.2551 17.1118 25.2423 17.0924 25.2283 17.0738C25.2183 17.0606 25.2074 17.048 25.1969 17.0352C25.1821 17.0171 25.1671 16.9992 25.1512 16.9819C25.1405 16.9702 25.1292 16.9588 25.118 16.9474C25.1088 16.9381 25.1002 16.9283 25.0907 16.9192L20.5039 12.5579L19.6862 7.59509L27.1156 10.6207C27.2155 10.6614 27.3188 10.6807 27.4204 10.6807C27.7396 10.6807 28.042 10.4905 28.1698 10.1767C28.3383 9.76291 28.1395 9.29093 27.7258 9.12243L19.0747 5.59929C18.9678 5.55573 18.857 5.53714 18.7486 5.54002C18.6858 5.53483 18.6217 5.53625 18.5567 5.54696L14.7023 6.18207C14.6431 6.19184 14.5868 6.20864 14.5334 6.23043C14.3999 6.25799 14.2714 6.31903 14.1619 6.41577L11.3938 8.86183L7.19696 8.11163H6.81048L6.45939 8.24983Z"
            fill="#0058FA"
          />
          <path
            d="M17.8729 2.5278C18.013 1.2792 17.1144 0.153445 15.8658 0.0133478C14.6172 -0.126749 13.4914 0.771868 13.3513 2.02047C13.2112 3.26906 14.1098 4.39482 15.3584 4.53492C16.607 4.67501 17.7328 3.7764 17.8729 2.5278Z"
            fill="#0058FA"
          />
          <path
            d="M29.7647 7.9339C30.0777 7.62089 30.0777 7.11341 29.7647 6.80041C29.4517 6.48741 28.9442 6.48742 28.6312 6.80043C28.3182 7.11344 28.3182 7.62092 28.6312 7.93392C28.9442 8.24692 29.4517 8.24691 29.7647 7.9339Z"
            fill="#FFB81D"
          />
          <path
            d="M3.09978 7.49704L5.49708 5.09976C5.5043 4.33898 5.19339 3.54176 4.57497 2.9233C3.43991 1.78825 1.70231 1.68554 0.693941 2.69389C-0.314471 3.7023 -0.211759 5.43989 0.923297 6.57493C1.54177 7.1934 2.33899 7.50432 3.09978 7.49704ZM3.36528 7.48239C3.36528 7.48239 4.09276 6.97757 4.73179 7.39189C5.37082 7.8062 6.25567 9 6.25567 9C6.25567 9 6.42422 8.95785 6.69103 8.69104C6.9579 8.42417 7 8.25567 7 8.25567C7 8.25567 5.80619 7.37088 5.39187 6.73181C4.97756 6.09278 5.48238 5.36531 5.48238 5.36531C5.48247 5.36428 5.48252 5.36321 5.48262 5.36213L3.36206 7.48268C3.36318 7.48253 3.36425 7.48248 3.36528 7.48239Z"
            fill="#FFB81D"
          />
        </g>
        <defs>
          <clipPath id="clip0_4837_103">
            <rect width="30" height="23.4516" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    key: 'pickle ball',
    label: 'Pickle Ball',
    svg: (
      <svg
        width="30"
        height="27"
        viewBox="0 0 30 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_4837_110)">
          <path
            d="M12.3823 13.2325L12.5706 13.9457L9.37996 16.0635C9.20763 16.1778 9.06184 16.3279 8.95243 16.5034C8.84301 16.6789 8.77251 16.8758 8.7457 17.0809L7.78331 24.4409C7.67975 25.233 8.23777 25.9589 9.02974 26.0626C9.09337 26.0708 9.15666 26.0748 9.21914 26.0748C9.93439 26.0748 10.556 25.5444 10.6514 24.816L11.5284 18.109L15.1472 15.7071L14.2943 19.3039C14.2385 19.5392 14.2426 19.7848 14.3062 20.0181C14.3698 20.2514 14.491 20.4651 14.6585 20.6395L19.7981 25.9893C19.933 26.1301 20.0949 26.242 20.2742 26.3183C20.4535 26.3947 20.6464 26.4339 20.8413 26.4336C21.2016 26.4335 21.5627 26.2997 21.843 26.0303C22.419 25.4769 22.4374 24.5614 21.884 23.9853L17.2907 19.2041L18.6946 13.284C18.7567 13.0219 18.7439 12.7475 18.6576 12.4923C18.6548 12.479 18.6527 12.4657 18.6492 12.4524L18.2944 11.1096L12.3823 13.2325ZM0.785789 12.2807L2.85635 13.3729C3.02352 13.461 3.2077 13.5122 3.3964 13.5229C3.58509 13.5336 3.77388 13.5036 3.94994 13.4349L4.77026 13.1147C4.78587 13.1087 4.80184 13.1048 4.81758 13.0992C4.86332 13.3048 4.97786 13.4885 5.14224 13.6201C5.30661 13.7517 5.51098 13.8232 5.72154 13.8228C5.91166 13.8229 6.09715 13.7642 6.2526 13.6547L6.59472 13.4145L7.99504 14.1533L8.44395 13.3021L7.47948 12.7933L9.84461 11.1327C9.97081 11.0441 10.0729 10.9253 10.1415 10.7872L11.1826 8.69282L11.7709 10.9197L17.2516 8.95164C17.1477 8.39825 16.8906 7.61705 16.2592 6.90943L16.5442 6.83144C17.2363 7.65523 17.4716 8.55583 17.5496 9.12739L11.5992 11.264C11.3682 11.347 11.1795 11.5183 11.0748 11.7404C10.9701 11.9624 10.9579 12.2169 11.0408 12.448C11.1238 12.679 11.2951 12.8676 11.5172 12.9724C11.7392 13.0771 11.9937 13.0893 12.2248 13.0063L18.8228 10.6372C18.9934 10.5759 19.1423 10.4658 19.251 10.3207C19.3596 10.1756 19.4233 10.0018 19.434 9.82078C19.44 9.71896 19.5212 8.00395 18.4529 6.30929C18.029 5.63685 17.4234 4.96833 16.5601 4.4043C16.1022 4.9718 15.4299 5.3668 14.6497 5.45462C14.542 5.46677 14.433 5.4729 14.3253 5.4729C13.7226 5.47322 13.1353 5.2827 12.6476 4.92865L11.213 5.30768C11.1406 5.32711 11.071 5.35556 11.0058 5.39237C10.8019 5.47797 10.6355 5.63407 10.5372 5.83215L8.58869 9.75275L5.91742 11.6282C5.85023 11.5014 5.79946 11.3666 5.76631 11.227L5.56731 10.3691C5.52459 10.185 5.44276 10.0122 5.32737 9.86253C5.21198 9.71284 5.06574 9.58973 4.89857 9.50156L2.828 8.40936C2.65705 8.31891 2.4699 8.26314 2.27732 8.24525C2.08474 8.22736 1.89053 8.2477 1.70583 8.30511C1.52099 8.36201 1.34921 8.45489 1.20037 8.57839C1.05154 8.70189 0.928573 8.85359 0.838548 9.02476L0.504523 9.65804L0.170498 10.2913C0.0800157 10.4623 0.0242156 10.6495 0.00630568 10.8421C-0.0116042 11.0347 0.00872926 11.2289 0.0661373 11.4136C0.123074 11.5984 0.215972 11.7702 0.339493 11.919C0.463014 12.0678 0.614608 12.1907 0.785789 12.2807Z"
            fill="#0058FA"
          />
          <path
            d="M14.9468 5.13243C16.3436 4.79163 17.1996 3.38306 16.8588 1.9863C16.518 0.589546 15.1094 -0.266473 13.7126 0.0743294C12.3159 0.415132 11.4599 1.8237 11.8007 3.22046C12.1415 4.61721 13.55 5.47323 14.9468 5.13243Z"
            fill="#0058FA"
          />
          <path
            d="M26.7199 12.402C26.5884 12.402 26.4816 12.2483 26.4816 12.0574C26.4816 11.8677 26.5884 11.7123 26.7199 11.7123C26.8519 11.7123 26.9582 11.8677 26.9582 12.0574C26.9582 12.2483 26.8519 12.402 26.7199 12.402ZM27.321 10.91C27.321 10.7694 27.4753 10.6551 27.6662 10.6551C27.857 10.6551 28.0107 10.7694 28.0107 10.91C28.0107 11.0488 27.857 11.1631 27.6662 11.1631C27.4753 11.1631 27.321 11.0488 27.321 10.91ZM28.2393 13.5928C28.085 13.5928 27.9593 13.5185 27.9593 13.4265C27.9593 13.3363 28.085 13.2625 28.2393 13.2625C28.393 13.2625 28.5176 13.3363 28.5176 13.4265C28.5176 13.5185 28.393 13.5928 28.2393 13.5928ZM28.2719 12.6408C28.0822 12.6408 27.9267 12.4865 27.9267 12.2957C27.9267 12.106 28.0822 11.9505 28.2719 11.9505C28.4627 11.9505 28.6164 12.106 28.6164 12.2957C28.6164 12.4865 28.4627 12.6408 28.2719 12.6408ZM29.5433 12.2174C29.4593 12.2174 29.3907 12.0797 29.3907 11.9123C29.3907 11.7431 29.4593 11.6054 29.5433 11.6054C29.6279 11.6054 29.6959 11.7431 29.6959 11.9123C29.6959 12.0797 29.6279 12.2174 29.5433 12.2174ZM29.3502 10.7574C29.3616 10.7705 29.3736 10.7837 29.385 10.7974C29.3942 10.8254 29.3924 10.8488 29.3804 10.8654C29.3422 10.914 29.2073 10.8757 29.0799 10.778C28.9524 10.6803 28.8816 10.5591 28.9199 10.51C28.9439 10.4803 28.9999 10.482 29.0713 10.5083C28.8353 10.3368 28.5564 10.2214 28.2536 10.1797C28.2656 10.1917 28.2719 10.2065 28.2719 10.2197C28.2702 10.2837 28.1382 10.3311 27.9782 10.3265C27.8187 10.3237 27.6896 10.2688 27.6913 10.2048C27.6913 10.1991 27.6924 10.1934 27.6959 10.1871C26.8307 10.3323 26.1719 11.0843 26.1719 11.9905C26.1719 12.4031 26.3084 12.7837 26.5387 13.09C26.5376 13.074 26.541 13.0603 26.549 13.05C26.5879 13.0003 26.7222 13.0391 26.849 13.1368C26.9759 13.2351 27.0479 13.3551 27.009 13.4054C26.9816 13.4408 26.9079 13.4317 26.8216 13.3888C27.1507 13.6683 27.5686 13.8215 28.0004 13.8208C29.0102 13.8208 29.829 13.0003 29.829 11.9905C29.829 11.5151 29.6479 11.082 29.3502 10.7574Z"
            fill="#FFB81D"
          />
        </g>
        <defs>
          <clipPath id="clip0_4837_110">
            <rect width="30" height="26.4338" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];

export const currencyType = [
  {
    currency: config.currencySGD,
    // symbol: '$',
  },
  {
    currency: config.currencyAUD,
    symbol: '$',
  },
  {
    currency: config.currencyGBP,
    symbol: '£',
  },
  {
    currency: config.currencyUSD,
    symbol: '$',
  },
];

export const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);

export const editListingSvg = (
  <svg width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.2165 18.0957H17.9873V22.6165H21.2165V18.0957Z" fill="#A95B2F" />
    <path d="M8.30046 18.0957H5.07129V22.6165H8.30046V18.0957Z" fill="#A95B2F" />
    <path
      d="M18.9565 1.16016L16.1878 5.13528L16.7988 6.01167H15.5775L15.2798 6.43921L15.8132 7.33369H16.4087L16.1491 7.76509L18.361 11.4987H16.3693L17.1075 12.6676H16.0393L18.755 16.9682H12.9425V18.298H26.505L23.0511 12.8297H24.8194L21.5631 7.33369H23.2571L18.9565 1.16016ZM7.42708 1.16016L3.12713 7.33369H4.87927L1.56421 12.8297H3.40613L0 18.298H12.2708V16.9676H6.45833L9.03521 12.8297H9.1366L9.96521 11.4993H8.02254L10.2817 7.75346L10.0337 7.33369H10.6162L11.1329 6.48249L10.8067 6.01167H9.5861L10.1964 5.13528L7.42708 1.16016Z"
      fill="#0058FA"
    />
    <path d="M14.7585 16.8047H11.5293V22.6172H14.7585V16.8047Z" fill="#A95B2F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.85228 18.9707C5.76698 18.9723 5.68574 19.0075 5.62633 19.0687C5.56691 19.13 5.53414 19.2122 5.53518 19.2975V21.7078C5.53518 21.7934 5.5692 21.8755 5.62976 21.9361C5.69032 21.9967 5.77245 22.0307 5.8581 22.0307C5.94374 22.0307 6.02588 21.9967 6.08643 21.9361C6.14699 21.8755 6.18101 21.7934 6.18101 21.7078V19.2975C6.18154 19.2543 6.1734 19.2115 6.15708 19.1715C6.14076 19.1316 6.11659 19.0953 6.08601 19.0649C6.05542 19.0344 6.01903 19.0103 5.979 18.9941C5.93896 18.978 5.8961 18.97 5.85293 18.9707H5.85228ZM12.4927 17.6836C12.4073 17.685 12.3259 17.7201 12.2664 17.7814C12.2068 17.8426 12.174 17.925 12.175 18.0104V21.6826C12.175 21.7682 12.209 21.8504 12.2696 21.911C12.3301 21.9715 12.4123 22.0055 12.4979 22.0055C12.5836 22.0055 12.6657 21.9715 12.7262 21.911C12.7868 21.8504 12.8208 21.7682 12.8208 21.6826V18.0104C12.8214 17.9672 12.8132 17.9244 12.7969 17.8844C12.7806 17.8445 12.7564 17.8082 12.7258 17.7777C12.6952 17.7472 12.6588 17.7232 12.6188 17.7071C12.5788 17.6909 12.5359 17.6829 12.4927 17.6836ZM18.7696 18.9707C18.6842 18.9721 18.6028 19.0072 18.5432 19.0685C18.4837 19.1297 18.4508 19.2121 18.4518 19.2975V21.7078C18.4518 21.7934 18.4859 21.8755 18.5464 21.9361C18.607 21.9967 18.6891 22.0307 18.7748 22.0307C18.8604 22.0307 18.9425 21.9967 19.0031 21.9361C19.0637 21.8755 19.0977 21.7934 19.0977 21.7078V19.2975C19.0982 19.2543 19.0901 19.2115 19.0737 19.1715C19.0574 19.1316 19.0333 19.0953 19.0027 19.0649C18.9721 19.0344 18.9357 19.0103 18.8957 18.9941C18.8556 18.978 18.8128 18.97 18.7696 18.9707Z"
      fill="#D2885E"
    />
    <path
      d="M13.1439 0L8.84392 6.17353H10.5909L7.28101 11.6605H9.12228L5.7168 17.1301H20.571L17.117 11.6605H19.0068L15.7537 6.17353H17.4438L13.1439 0Z"
      fill="#FFB81D"
    />
  </svg>
);

export const checkMark = (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 5.8L3.85714 9L11 1"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </svg>
);
